import { render, staticRenderFns } from "./NavItemTop.vue?vue&type=template&id=b22bc3ca&scoped=true&"
import script from "./NavItemTop.vue?vue&type=script&lang=js&"
export * from "./NavItemTop.vue?vue&type=script&lang=js&"
import style0 from "./NavItemTop.vue?vue&type=style&index=0&id=b22bc3ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22bc3ca",
  null
  
)

export default component.exports